import gql from "graphql-tag";

export const CREATE_SHARED_COMPONENT = gql`
    mutation CreateSharedComponent(
        $personId: ID!
        $componentId: ID!
        $label: String!
    )
    {
        CreateSharedComponent(
            personId: $personId,
            componentId: $componentId
            label: $label
        ) {
            uri,
            status,
            accessCount,
            lastAccessedDate { formatted },
            playCount,
            lastPlayedDate { formatted },
            downloadCount,
            lastDownloadedDate { formatted },
            creator{
              id,
              fullName,
              imageDepictions {
                id,
                title,
                type,
                thumbnail { 
                  id, 
                  file {
                    mimeType, 
                    uri 
                  }
                }
              }
            }
        }
    }
`;

export const CREATE_OR_PUBLISH_SHARED_COMPONENT = gql`
  mutation CreateOrPublishSharedComponent(
    $personId: ID!
    $componentId: ID!
    $shareComponentUri: String!
    $label: String!
  )
  {
    CreateOrPublishSharedComponent(
      personId: $personId
      componentId: $componentId
      shareComponentUri: $shareComponentUri
      label: $label
    ) {
      uri,
      status,
      accessCount,
      lastAccessedDate { formatted },
      playCount,
      lastPlayedDate { formatted },
      downloadCount,
      lastDownloadedDate { formatted },
      creator{
        id,
        fullName,
        imageDepictions {
          id,
          title,
          type,
          thumbnail { 
            id, 
            file {
              mimeType, 
              uri 
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_SHARED_COMPONENT = gql`
    mutation UpdateSharedComponent(
        $sharedComponentUri: String!
        $newStatus: SharedComponentStatus
    )
    {
        UpdateSharedComponent(
            sharedComponentUri: $sharedComponentUri,
            newStatus: $newStatus
        ) {
            uri,
            status,
            accessCount,
            lastAccessedDate { formatted },
            playCount,
            lastPlayedDate { formatted },
            downloadCount,
            lastDownloadedDate { formatted },
            creator{
              id,
              fullName,
              imageDepictions {
                id,
                title,
                type,
                thumbnail { 
                  id, 
                  file {
                    mimeType, 
                    uri 
                  }
                }
              }
            }
        }
    }
`;

export const INCREMENT_SHARED_COMPONENT_PLAY_COUNT = gql`
    mutation incrementSharedComponentPlayCount(
        $sharedComponentUri: String!
    )
    {
        IncrementSharedComponentPlayCount(
            sharedComponentUri: $sharedComponentUri,
        )
    }
`;

export const INCREMENT_SHARED_COMPONENT_DOWNLOAD_COUNT = gql`
    mutation incrementSharedComponentDownloadCount(
        $sharedComponentUri: String!
    )
    {
        IncrementSharedComponentDownloadCount(
            sharedComponentUri: $sharedComponentUri,
        )
    }
`;


export const GET_SHARED_COMPONENT = gql`
  mutation SharedComponent(
    $uri: String!
    $incrementAccessCount: Boolean
  )
  {
    SharedComponent(
      uri: $uri,
      incrementAccessCount: $incrementAccessCount
    )
    {
      id,
      uri,
      creator{
        id,
        fullName,
        alias,
        description,
      },
      component {
        id,
        title,
        subtitle,
        version,
        project {
          id
        },
        file {
          id,
          uri,
          fileName,
          mimeType,
          fileType,
          size,
          bitDepth,
          samplingRate
        }
        creationDate {
          formatted
        },
        lastModifiedDate {
          formatted
        },
        contributions {
          id,
          role,
          isArchived,
          contributor {
            id,
            accountId,
            fullName,
            alias
            imageDepictions {
              id,
              title,
              type,
              thumbnail {
                id,
                file {
                  mimeType,
                  uri
                }
              }
            }
            __typename
          }
        }
        isContributionOf {
          id,
          role,
          isArchived
          contributor {
            id,
            accountId,
            fullName,
            alias
            imageDepictions {
              id,
              title,
              type,
              thumbnail {
                id,
                file {
                  mimeType,
                  uri
                }
              }
            }
            __typename
          }
        }
      }
    }
  }
`;
